import { createRequest, getProxyHeadersPlugin } from '@direct-frontend/modules-request';

export const request = createRequest({
    baseUrl: __API_ORIGIN__ + '/api/checkout/v1',
    credentials: 'include',
    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
    },
    // Нет смысла делать ретраи, т.к. сейчас уже реализованы несколько ступеней ретраев — на балансере бекенда и на балансере фронтбека
    retry: 0,
    agent: false,
    timeout: { connect: 100, request: __YENV__ === 'production' ? 7000 : 10000 },
    jsonContentTypeHeaders: ['application/json'],
    plugins: [
        getProxyHeadersPlugin([
            'x-original-host',
            'cookie',
            'user-agent',
            'accept-language',
            'x-trace-id',
            'traceparent',
        ]),
    ],
});
